import { $emitter } from '@/services/emitter';
import { setAuthToken } from '@/services/api/main/axios';

export default (to: any, from: any, next: Function) => {
  setAuthToken(to.query.token);

  $emitter.emit('login:external');
  return next({ name: 'register-currency' });
};
